<template>
  <PaymentNoticeModal
    v-if="openModal"
    :isOpen="openModal"
    :reload="reload"
    :paymentNotice="paymentNotice"
    :close="modalClose"
  />
  <div class="inline-block min-width-full rounded-lg shadow bg-white p-4">
    <div class="inline-flex justify-between w-full flex-wrap mb-5 gap-2">
      <div class="inline-flex gap-2 items-center justify-start ">
        <b-input-group>
          <b-form-input
            class="w-50"
            placeholder="공지사항 제목을 입력하세요."
            v-model="search.title"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <Button :type="ButtonTypes.blue" label="검색" :on-click="handleSearch"/>
          </b-input-group-append>
        </b-input-group>
        <div class="min-w-[100px]">
          <b-form-checkbox
            v-model="search.checkDeleted"
            v-on:click="handleChangeCheckbox"
          >
            삭제 포함
          </b-form-checkbox>
        </div>
      </div>
      <div>
        <Button :type="ButtonTypes.purple" label="등록" :on-click="modalClose"/>
      </div>
    </div>
    <b-table :fields="fields" :items="paymentNotices" class="text-left min-width-full ">
      <template #cell(status)="data">
        <Badge
          :type="data.item.status === FilePublishTypes.UNPUBLISHED ? BadgeTypes.red : BadgeTypes.green"
          :label="data.item.status"
        />
      </template>
      <template #cell(createdAt)="data">
        {{getDate(data.item.createdAt)}}
      </template>
      <template #cell(button)="data">
        <div class="inline-flex gap-2 justify-end items-center text-right w-full">
          <span v-if="data.item.deletedAt !== null">{{getDate(data.item.deletedAt)}} 삭제</span>
          <Button
            v-if="!data.item.blue"
            :type="ButtonTypes.yellow" label="상세" :onClick="() => setDetail(data.item)" />
          <Button
            v-if="!data.item.deletedAt"
            :type="ButtonTypes.red" label="삭제" :onClick="() => deleteNotice(data.item.id)" />
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import {BadgeTypes, ButtonTypes, PublishTypes} from "@/util/enums";
import Badge from "@/components/Badge.vue";
import Button from "@/components/Button.vue";
import customDate from "@/util/custom-date";
import PaymentNoticeModal from "@/components/modals/PaymentNoticeModal.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
    FilePublishTypes() {
      return PublishTypes
    }
  },
  components: {PaymentNoticeModal, Button, Badge},
  data() {
    return {
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      openModal: false,
      fields: [
        {
          label: '제목',
          key: 'title',
        },
        {
          label: '노출상태',
          key: 'status',
        },
        {
          label: '생성일',
          key: 'createdAt',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      paymentNotices: [],
      search: {
        title: "",
        checkDeleted: false
      },
      paymentNotice: null,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    if (query.checkDeleted === 'true') {
      this.search.checkDeleted = true
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    setDetail(paymentNotice) {
      this.paymentNotice = paymentNotice
      this.openModal = !this.openModal
    },
    modalClose() {
      this.openModal = !this.openModal
      this.paymentNotice = null
    },
    handleChangeCheckbox() {
      this.search.checkDeleted = !this.search.checkDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    deleteNotice(id){
      api.paymentNotice.delete(id,(response) => {
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
      })
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
        widthDelete: this.search.checkDeleted
      }
      
      api.paymentNotice.search(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.paymentNotices = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>